import React from 'react'
import ReactDOM from 'react-dom/client'
import Map from '../common/components/property_map'
import { PropertyData } from '../common/models/properties'
import Loading from '../common/components/loading'

import $ from 'jquery'

$(function() {
  $('.property-map').each(function() {
    var $map = $(this);

    const root = ReactDOM.createRoot($map[0]);
    root.render(
      <PropertyMap property={$map.data('property')} />
    );
  })
})

interface PropertyMapProps {
  property: string
}

interface PropertyMapState {
  loading: boolean
  focused?: PropertyData
  nearby?: PropertyData[]
}

class PropertyMap extends React.Component<PropertyMapProps, PropertyMapState> {
  constructor(props: PropertyMapProps) {
    super(props)

    fetch(`/api/v1/properties/${props.property}/surroundings`, {
      method: "GET",
      credentials: 'same-origin'
    })
    .then(resp => { return resp.json() })
    .then(json => {
      this.setState({
        loading: false,
        focused: json.property,
        nearby: json.surroundings
      })
    })

    this.state = {
      loading: true
    }
  }

  render() {
    if (this.state.loading) {
      return <Loading />
    } else {
      return (
        <Map
          compactInfo={true}
          focalProperty={this.state.focused}
          properties={this.state.nearby}
          defaultZoom={7}
          fadedMarkers={true}
        />
      )
    }
  }
}

/*
const PropertyGoogleMap = withGoogleMap(props => (
  <GoogleMap
    ref={props.onMapLoad}
    defaultZoom={11}
    center={props.center}
    onClick={props.onMapClick}
    defaultOptions={{
      streetViewControl: false,
      scaleControl: false,
      mapTypeControl: false,
      panControl: false,
      zoomControl: true,
      styles: GoogleMapStyle,
      zoomControlOptions: {
        position: google.maps.ControlPosition.LEFT_BOTTOM
      },
      rotateControl: false,
      fullscreenControl: false
    }}
  >
    <Marker 
      position={props.center}
      icon={props.icon}
    />
  </GoogleMap>
))

class PropertyMap extends React.Component {
  static get defaultProps() {
    return {
      lat: 0,
      lng: 0,
      type: 'villas'
    }
  }

  render() {
    const { lat, lng, type } = this.props

    return (
      <PropertyGoogleMap
        containerElement={
          <div style={{ width: `100%`, height: `100%` }} />
        }
        mapElement={
          <div style={{ width: `100%`, height: `100%` }} />
        }
        center={{ lat: lat, lng: lng }}
        icon={propertyMarker(type)}
      />
    )
  }
}*/
